var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFridge = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02924 27.6574C1.22807 27.6574 0 26.3942 0 24.5346V3.36499C0 1.50535 1.22807 0.242188 3.02924 0.242188H14.9591C16.7602 0.242188 18 1.50535 18 3.36499V24.5346C18 26.3942 16.7602 27.6574 14.9591 27.6574H3.02924ZM2.47953 3.51704V9.69248H15.5205V3.47026C15.5205 3.01412 15.2164 2.72172 14.7719 2.72172H3.26316C2.79532 2.72172 2.47953 3.03751 2.47953 3.51704ZM4.74854 8.11353C4.32749 8.11353 4.02339 7.82113 4.02339 7.38839V4.75681C4.02339 4.32406 4.32749 4.03166 4.74854 4.03166C5.16959 4.03166 5.47368 4.32406 5.47368 4.75681V7.38839C5.47368 7.82113 5.16959 8.11353 4.74854 8.11353ZM2.47953 21.8094H15.5205V11.4001H2.47953V21.8094ZM4.74854 16.4878C4.32749 16.4878 4.02339 16.1837 4.02339 15.7627V13.1194C4.02339 12.6983 4.32749 12.3942 4.74854 12.3942C5.16959 12.3942 5.47368 12.6983 5.47368 13.1194V15.7627C5.47368 16.1837 5.16959 16.4878 4.74854 16.4878ZM3.26316 25.1779H14.7719C15.2164 25.1779 15.5205 24.8738 15.5205 24.4293V23.517H2.47953V24.3825C2.47953 24.8621 2.79532 25.1779 3.26316 25.1779Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFridge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fridge.4451154a.svg";
export { ForwardRef as ReactComponent };